export default __webpack_public_path__ + "static/media/bookcase.89c5d204.png";